import { createFileRoute } from '@tanstack/react-router'

import { PortfolioRiskKpisScreen } from './-components/portfolio-risk-kpis-screen.tsx'

export const Route = createFileRoute('/risk/portfolio-risk-kpis')({
  component: PortfolioRiskKpisScreen
})
